<template>
  <div class="swipe-container">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(pic, index) in swipeList" :key="index">
        <a :href="pic.eventBannerRedirectPath">
          <img :src="$isCdn(pic.eventBannerPath)" alt="" />
        </a>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: ['swipeList'],
  data() {
    return {
      suffix: 'https://'
    }
  }
}
</script>

<style scoped lang="scss">
.swipe-container {
  padding: 12px 0;
  img {
    width: 100%;
    max-height: 200px;
    border-radius: 4px;
  }
}
</style>
